import { styled } from '@mui/material';

export const ProjectRateWrapper = styled('div')({
  textAlign: 'center',
});
